module.exports = __webpack_public_path__ + "media/assets/images/vector-fcd9878c0cf75c337e6d8b5c84ac8d24.svg";